import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from '../../utils/API/requestMiddleware';


const regulationRequestAPI = createApi({
    baseQuery: defautBaseQuery, // Replace with your API endpoint
    reducerPath: 'regulationRequestAPI',
    endpoints: (builder) => ({
        addRegulationRequest: builder.mutation({
            query: (details) => ({
                url: '/RegulationRequest/AddRegulationRequest',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllRegulationNameList: builder.query({
            query: () => ({
                url: (`/RegulationRequest/GetAllRegulationNameList`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getRegulationRequestById: builder.query({
            query: (id) => ({
                url: (`/RegulationRequest/GetRegulationRequestById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getRegulationOutputFileById: builder.query({
            query: (id) => ({
                url: (`/RegulationRequest/GetRegulationOutputFileById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getGridData: builder.query({
            query: function (params) {
                const { url } = params;
          
                let { first, rows, sortField, sortOrder,search, ...retVal } = params.params;

                retVal.Pagination = {
                    PageNumber: (first / rows) + 1,
                    PageSize: rows
                };
                retVal.filters= { searchText:search || ""};
                retVal.sortString='';
                //retVal.pageIndex = (first / rows);
                //retVal.pageSize = rows;

                if (sortField) {
                    retVal.sortField = sortField;
                    retVal.sortDesc = sortOrder < 0;
                }

                return {
                    url: params.url,
                    params: { queryRequest: JSON.stringify(retVal) }
                };
            },
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    // useGetRegulationsMutation,
    useAddRegulationRequestMutation,
    useLazyGetAllRegulationNameListQuery,
    useLazyGetRegulationRequestByIdQuery,
    useLazyGetRegulationOutputFileByIdQuery,
    useLazyGetGridDataQuery,
    
} = regulationRequestAPI;

export default regulationRequestAPI;